// @flow
import * as React from "react";
import DropDown from "../DropDown";
import { DropDownItem } from "../DropDown";
import { fetchJson } from "../../lib/Fetching";

type Protocol = {
  id: number,
  name: string,
};

type Props = {
  company_id: ?number,
  onProtocolChange: (?Protocol) => void,
  value: ?number,
  includeBlank?: boolean,
  blankLabel?: string,
  onProtocolsLoaded?: (Array<Protocol>) => void,
};

export default function ProtocolDropDown({
                                           company_id,
                                           onProtocolChange,
                                           value,
                                           includeBlank = false,
                                           blankLabel = I18n.t("select_protocol"),
                                           onProtocolsLoaded,
                                         }: Props) {
  const [protocols, setProtocols] = React.useState<Array<Protocol>>([]);

  React.useEffect(() => {
    if (!company_id) {
      setProtocols([]);
      if (onProtocolsLoaded) onProtocolsLoaded([]);
      return;
    }

    fetchJson("/products/shelf_life_protocols.json", { company_id })
        .then((json: { testing_protocols: Array<Protocol> }) => {
          const sorted = (json.testing_protocols || []).sort((a, b) =>
              a.name.localeCompare(b.name)
          );

          setProtocols(sorted);
          if (onProtocolsLoaded) onProtocolsLoaded(sorted);
        });
  }, [company_id, includeBlank, onProtocolChange, onProtocolsLoaded, value]);

  const protocolOptions: Array<DropDownItem> = React.useMemo(() => [
    ...(includeBlank ? [{ value: "", label: blankLabel }] : []),
    ...protocols.map((p) => ({ value: p.id, label: p.name })),
  ], [protocols, includeBlank, blankLabel]);

  const handleChange = (selected: ?DropDownItem) => {
    const protocol = protocols.find((p) => p.id === (selected && selected.value));
    onProtocolChange(protocol || null);
  };

  return (
      <DropDown
          options={protocolOptions}
          value={value}
          placeholder={blankLabel}
          onChange={handleChange}
          isClearable={true}
      />
  );
}
